<template>
  <div>
    <div class="my-profile section-group">
      <div class="row">
        <div class="col-12">
          <div class="form-group row multi_group_name">
            <div class="multi_group_name">
               {{ $t('Social.group.groupSetting.setGroup') }} :
              <el-select v-model="form.id" :placeholder="$t('Social.group.groupSetting.placeholder')" @change="selectChange" clearable>
                <el-option v-for="(item, ix) in groupList" :key="item.id" :label="item.sgL_GroupName" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group row">
            <label for="file-ip-2" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.Groupflags') }}</label>
            <div class="group-upload-inputB">
              <el-upload class="avatar-uploader" :auto-upload="false" action="" :show-file-list="false"
                :on-change="changeUpload" ref="avatarUploader">
                <img v-if="form.sgL_Logo" :src="form.sgL_Logo" class="avatar" style="width: 50px; height: 50px" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <ImgCropperVue ref="cro" @cropperConfirm="cropperConfirm" :props_autoCropWidth="200"
                :props_autoCropHeight="200" :props_full="false" :props_original="true" :props_centerBox="true"
                :props_high="false" :props_fixed="true" :props_info="true" :props_canMove="true" :props_canScale="true">
              </ImgCropperVue>
            </div>
          </div>
          <div class="form-group row">
            <label for="username" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.groupname') }}</label>
            <div class="col-sm-10">
              <el-input v-model="form.sgL_GroupName" :placeholder="$t('Social.group.groupSetting.sgL_GroupName')"></el-input>
            </div>
          </div>
          <div class="form-group row">
            <label for="bio" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.groupdes') }}</label>
            <div class="col-sm-10">
              <el-input v-model="form.sgL_GroupContent" :placeholder="$t('Social.group.groupSetting.sgL_GroupContent')"></el-input>
            </div>
          </div>
          <!-- <div class="form-group row">
            <label for="user-url" class="col-sm-2 col-form-label"
              >自定申請連接(選填)</label
            >
            <div class="col-sm-10">
              <el-input
                v-model="form.sgL_GroupUrl"
                :placeholder="這連接可提供尋寶網會員申請入群組"
              ></el-input>
            </div>
          </div> -->
          <div class="form-group row">
            <label for="foruserMessage" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.foruserMessage') }}</label>
            <!-- radio -->
            <div class="col-sm-10 col-form-label">
              <div class="icheck-primary d-inline mr-4">
                <el-radio-group v-model="form.sgL_SendMessage">
                  <el-radio :label="true"> {{ $t('Social.group.groupSetting.OPEN') }}</el-radio>
                  <el-radio :label="false"> {{ $t('Social.group.groupSetting.NO_OPEN') }}</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="foruserMessage" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.Groupvideo') }}</label>
            <!-- radio -->
            <div class="col-sm-10 col-form-label">
              <div class="icheck-primary d-inline mr-4">
                <el-radio-group v-model="form.sgL_SendVideo">
                  <el-radio :label="true"> {{ $t('Social.group.groupSetting.OPEN') }}</el-radio>
                  <el-radio :label="false"> {{ $t('Social.group.groupSetting.NO_OPEN') }}</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="foruserMessage" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.Disable') }}</label>
            <!-- radio -->
            <div class="col-sm-10 col-form-label">
              <div class="icheck-primary d-inline mr-4">
                <el-radio-group v-model="form.sgL_SendPush">
                  <el-radio :label="true"> {{ $t('Social.group.groupSetting.OPEN') }}</el-radio>
                  <el-radio :label="false"> {{ $t('Social.group.groupSetting.NO_OPEN') }}</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="backgroundImage" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.Groupbackground') }}</label>
            <div class="group-upload-input">
              <div class="preview">
                <el-upload class="avatar-uploader" :auto-upload="false" action="" :show-file-list="false"
                  :on-change="changeUpload2" ref="avatarUploader">
                  <img v-if="form.sgL_BackImage" :src="form.sgL_BackImage" style="width: 100px; height: 50px"
                    class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <ImgCropperVue ref="cro2" @cropperConfirm="cropperConfirm2" :props_autoCropWidth="1080"
                :props_autoCropHeight="720" :props_full="false" :props_original="true" :props_centerBox="true"
                :props_high="false" :props_fixed="true" :props_info="true" :props_canMove="true" :props_canScale="true">
              </ImgCropperVue>
            </div>
          </div>
          <div class="form-group row">
            <label for="backgroundImage" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.background_color') }}</label>
            <el-color-picker v-model="form.backColor"></el-color-picker>
          </div>
          <div class="form-group row">
            <label for="backgroundImage" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.wordcolor') }}</label>
            <el-color-picker v-model="form.fontColor"></el-color-picker>
          </div>
          <div class="form-group row">
            <label for="foruserMessage" class="col-sm-2 col-form-label">{{ $t('Social.group.groupSetting.Delgroup') }}</label>
            <div class="col-sm-10 col-form-label">
              <a href="javascript:" @click.prevent="deleteInfo" class="btn btn-primary"><i
                  class="fas fa-trash-alt"></i></a>
              <p>({{ $t('Social.group.groupSetting.details') }})</p>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-8">
              <a href="javascript:" class="btn btn-secondary" @click="cancel">{{ $t('Social.group.groupSetting.cancel') }}</a>
              <input type="submit" :value="$t('Social.group.groupSetting.save')" class="btn btn-primary float-right" @click="save" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgCropperVue from "@/components/common/ImgCropper.vue";
import avatarVue from "@/components/common/avatar.vue";
export default {
  components: {
    ImgCropperVue,
    avatarVue,
  },
  data() {
    return {
      groupList: [],
      form: {
        id: "",
        sgL_GroupName: "",
        sgL_Logo: "",
        sgL_GroupContent: "",
        sgL_GroupUrl: "",
        sgL_SendMessage: true,
        sgL_SendVideo: true,
        sgL_BackgroundAndWord: "",
        sgL_BackImage: "",
        backColor: "#FFF",
        fontColor: "#737373",
        sgL_SendPush: true,
      },
    };
  },
  created() {
    this.GroupGetAll();
    if (this.$route.query && this.$route.query.id) {
      this.selectChange(this.$route.query.id);
    }
  },
  methods: {
    formReset() {
      return {
        id: "",
        sgL_GroupName: "",
        sgL_Logo: "",
        sgL_GroupContent: "",
        sgL_GroupUrl: "",
        sgL_SendMessage: true,
        sgL_SendVideo: true,
        sgL_BackgroundAndWord: "",
        sgL_BackImage: "",
        backColor: "#FFF",
        fontColor: "#737373",
        sgL_SendPush: true,
      };
    },
    selectChange(n) {
      if (n) {
        this.$api.social
          .GroupGet({
            Id: n,
          })
          .then((res) => {
            this.form = Object.assign(this.formReset(), res.data.result, {
              backColor: res.data.result.sgL_BackgroundAndWord.split(",")[0],
              fontColor: res.data.result.sgL_BackgroundAndWord.split(",")[1],
            });
          });
      } else {
        this.form = this.formReset();
      }
    },
    GroupGetAll() {
      this.$api.social
        .GroupGetAll({
          SkipCount: 0,
          MaxResultCount: 10,
        })
        .then((res) => {
          this.groupList = res.data.result.items;
        });
    },
    changeUpload(file, fileList) {
      switch (file.raw.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            message: "請選擇jpg/png格式",
          });
          this.$refs.cro.clearFiles();
          return;
      }
      let test = new Image();
      test.src = window.URL.createObjectURL(file.raw);
      let width = 0;
      let height = 0;
      let that = this;
      test.onload = function () {
        width = test.width;
        height = test.height;
        if (width < 200 || height < 200) {
          that.$message({
            message: "請選擇尺寸大於200*200的圖片",
          });
          this.$refs.cro.clearFiles();
          return;
        }
        that.$refs.cro.initData(file);
        that.$refs.cro.setDialogVisible(true);
      };
    },
    changeUpload2(file, fileList) {
      switch (file.raw.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            message: "請選擇jpg/png格式",
          });
          this.$refs.cro2.clearFiles();
          return;
      }
      this.$refs.cro2.initData(file);
      this.$refs.cro2.setDialogVisible(true);
    },
    cropperConfirm(img) {
      let formData = new FormData();
      formData.append("file", img, "DX.jpg");
      formData.append("Type", "Community");
      this.$api.blog.UploadBlog(formData).then((res) => {
        if (res.data.success) {
          this.form.sgL_Logo = res.data.result.url;
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
      this.$refs.cro.setDialogVisible(false);
    },
    cropperConfirm2(img) {
      let formData = new FormData();
      formData.append("file", img, "DX.jpg");
      formData.append("Type", "Community");
      this.$api.blog.UploadBlog(formData).then((res) => {
        if (res.data.success) {
          this.form.sgL_BackImage = res.data.result.url;
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
      this.$refs.cro2.setDialogVisible(false);
    },
    save() {
      let action = null;
      if (this.form.id) {
        action = this.$api.social.GroupUpdate;
      } else {
        this.form.id = 0;
        action = this.$api.social.GroupCreate;
      }
      action(
        Object.assign(this.form, {
          sgL_BackgroundAndWord:
            this.form.backColor + "," + this.form.fontColor,
        })
      ).then((res) => {
        if (res.data.success) {
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
          if (!this.form.id) {
            this.GroupGetAll();
            this.form.id = res.data.result.id;
          }
        } else {
          let errormsg = "";
          for (let i = 0; i < res.data.error.validationErrors.length; i++) {
            errormsg += res.data.error.validationErrors[i].message + ',';
          }
          this.$message.error({
            type: "error",
            message: errormsg.substring(0, errormsg.lastIndexOf(',')),
          });
        }
      });
    },
    cancel() {
      this.form = this.formReset();
    },
    deleteInfo() {
      if (!this.form.id) {
        return;
      }
      this.$api.social
        .GroupDelete({
          id: this.form.id,
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
            this.GroupGetAll();
            this.form = this.formReset();
          } else {
            this.$message.error({
              type: "error",
              message: res.data.error.message,
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.avatar-uploader {
  background-color: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/group/groupSetting.vue